import type { ProductListItem } from 'types/capi/shared';
import type { User } from 'types/User';

import algolia from '~/services/algolia.client';

import UserEvent from './UserEvent';

type EventData = {
  isBot: boolean;
  product: ProductListItem;
  user: User;
};

class ProductClickedEvent extends UserEvent<EventData> {
  sendToAlgolia() {
    if (!this.data.product.queryID) return;
    if (!this.data.product.position) return;

    algolia.clickedObjectIdAfterSearch({
      id: this.data.product.id.toString(),
      position: this.data.product.position,
      queryID: this.data.product.queryID,
      user: this.data.user
    });
  }

  collectServerEvents() {
    this.serverEvents.push({
      data: {
        position: this.data.product.position,
        stock_status: this.data.product.stock_status
      },
      type: 'plp_product_clicked'
    });
  }
}

export default ProductClickedEvent;
